import { render, staticRenderFns } from "./FAQMentor.vue?vue&type=template&id=6a901478&scoped=true&"
import script from "./FAQMentor.vue?vue&type=script&lang=js&"
export * from "./FAQMentor.vue?vue&type=script&lang=js&"
import style0 from "./FAQMentor.vue?vue&type=style&index=0&id=6a901478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a901478",
  null
  
)

export default component.exports